// Module
var code = `{{#if (.addBidButtonOnSmallOE && ._userPreferredShowAddBidAsk) || 
      (.buyAskButtonOnSmallOE && ._userPreferredShowSellBidBuyAsk) || 
      (.buyMarketButtonOnSmallOE && ._userPreferredShowBuySellMarket) }}

    <div class="js-chart-buttons-container" {{^.oeSmall}}style="float:left;{{^~/reverseButtons}}margin-left:12px;{{/}}" {{/}}>
        {{#if .oeSmall}}
            {{#if .reverseButtons}}
                {{#if .buyMarketButtonOnSmallOE && ._userPreferredShowBuySellMarket}}
                    <terceraButton terceraButtonStyle="js-button-blue"
                                   text="{{.buyMarketText}}"
                                   on-btnClick="buy_market"
                                   enabled="{{.tradingMarketAllowed}}"
                                   isRelative="true"
                                   tooltip="{{!.tradingMarketAllowed && .tradingMarketAllowedReason ? .tradingMarketAllowedReason : ''}}" />
                {{/if}}

                {{#if .buyAskButtonOnSmallOE && ._userPreferredShowSellBidBuyAsk}}
                    <terceraButton terceraButtonStyle="js-button-blue"
                                   text="{{.buyAskText}}"
                                   on-btnClick="buy_Ask"
                                   enabled="{{.tradingLimitAllowed}}"
                                   isRelative="true"
                                   tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
                {{/if}}

                {{#if .addBidButtonOnSmallOE && ._userPreferredShowAddBidAsk}}
                    <terceraButton terceraButtonStyle="js-button-blue"
                                   text="{{.addBidText}}"
                                   on-btnClick="add_Bid"
                                   enabled="{{.tradingLimitAllowed}}"
                                   isRelative="true"
                                   tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
                {{/if}}
            {{else}}
                {{#if .addBidButtonOnSmallOE && ._userPreferredShowAddBidAsk}}
                    <terceraButton terceraButtonStyle="js-button-blue"
                                   text="{{.addBidText}}"
                                   on-btnClick="add_Bid"
                                   enabled="{{.tradingLimitAllowed}}"
                                   isRelative="true"
                                   tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
                {{/if}}

                {{#if .buyAskButtonOnSmallOE && ._userPreferredShowSellBidBuyAsk}}
                    <terceraButton terceraButtonStyle="js-button-blue"
                                   text="{{.buyAskText}}"
                                   on-btnClick="buy_Ask"
                                   enabled="{{.tradingLimitAllowed}}"
                                   isRelative="true"
                                   tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
                {{/if}}

                {{#if .buyMarketButtonOnSmallOE && ._userPreferredShowBuySellMarket}}
                    <terceraButton terceraButtonStyle="js-button-blue"
                                   text="{{.buyMarketText}}"
                                   on-btnClick="buy_market"
                                   enabled="{{.tradingMarketAllowed}}"
                                   isRelative="true"
                                   tooltip="{{!.tradingMarketAllowed && .tradingMarketAllowedReason ? .tradingMarketAllowedReason : ''}}" />
                {{/if}}
            {{/if}}
        {{else}}
            {{#if .buyMarketButtonOnSmallOE && ._userPreferredShowBuySellMarket}}
                <terceraButton terceraButtonStyle="js-button-blue"
                               text="{{.buyMarketText}}"
                               on-btnClick="buy_market"
                               enabled="{{.tradingMarketAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingMarketAllowed && .tradingMarketAllowedReason ? .tradingMarketAllowedReason : ''}}" />
            {{/if}}

            {{#if .buyAskButtonOnSmallOE && ._userPreferredShowSellBidBuyAsk}}
                <terceraButton terceraButtonStyle="js-button-blue"
                               text="{{.buyAskText}}"
                               on-btnClick="buy_Ask"
                               enabled="{{.tradingMarketAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingMarketAllowed && .tradingMarketAllowedReason ? .tradingMarketAllowedReason : ''}}" />
            {{/if}}

            {{#if .addBidButtonOnSmallOE && ._userPreferredShowAddBidAsk}}
                <terceraButton terceraButtonStyle="js-button-blue"
                               text="{{.addBidText}}"
                               on-btnClick="add_Bid"
                               enabled="{{.tradingMarketAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingMarketAllowed && .tradingMarketAllowedReason ? .tradingMarketAllowedReason : ''}}" />
            {{/if}}
        {{/if}}
    </div>
{{/if}}`;
// Exports
export default code;